import React, { useState } from "react";
import { FaCheck, FaDiscord } from "react-icons/fa";
import { Link } from "react-router-dom";
import { CDN_BASE_URL } from "../../config";
import { FaMedium, FaSquareXTwitter, FaX } from "react-icons/fa6";
import MediumModal from "../common/modals/MediumModal";
import TwitterModal from "../common/modals/TwitterModal";

const PostTwitterTask = ({ user, getData, reward }) => {
  const [showMedium, setshowMedium] = useState();

  return (
    <div
      className={`${
        user?.twitterPost === "progress" && "order-last opacity-40"
      } flex justify-between gap-3 items-center relative py-2 pb-4 border-b`}
    >
      {showMedium && (
        <>
          <div
            onClick={() => setshowMedium(false)}
            className="w-full h-full z-40 bg-black/50 fixed top-0 left-0"
          ></div>
          <TwitterModal setShow={setshowMedium} getData={getData} />
        </>
      )}
      <span className="flex items-center gap-2 lg:gap-4">
        <FaSquareXTwitter className="text-[32px] sm:text-[54px] lg:text-[72px]" />
        <span>
          <h4 className="font-bold text-[14px] lg:text-[28px] lg:-mb-2">
            Tweet about Filetrust
          </h4>
          <span className="font-bold text-[16px] lg:text-[28px] flex gap-1 items-center">
            <img src="/gold.png" className="w-6 lg:w-8" alt="GOLD" />+{reward}
          </span>
        </span>
      </span>
      {user?.twitterPost ? (
        <span>
          {" "}
          <button
            disabled={user?.twitterPost === "progress"}
            onClick={() => setshowMedium(true)}
            className="start-button px-4 lg:px-8 py-2 bg-[#02006A] shadow shadow-white/40 rounded-full text-[14px] lg:text-[24px] flex gap-2 items-center"
          >
            {user?.twitterPost === "progress" ? (
              <>in Progress...</>
            ) : (
              <>Start</>
            )}
          </button>
          {user?.twitterPost === "checked" ? (
            <span className="text-green-500 text-[14px] text-center">
              last one is approved
            </span>
          ) : user?.twitterPost === "rejected" ? (
            <span className="text-red-500 text-[14px] text-center">
              last one is rejected
            </span>
          ) : null}
        </span>
      ) : (
        <span className="flex flex-wrap gap-2 justify-end">
          <button
            onClick={() => setshowMedium(true)}
            className="start-button px-4 lg:px-8 py-2 bg-[#02006A] shadow shadow-white/40 rounded-full text-[14px] lg:text-[24px] flex gap-2 items-center"
          >
            Start
          </button>
        </span>
      )}
    </div>
  );
};

export default PostTwitterTask;
